SET_USER_VIDEO_DATA_FEATURE_POSITION